import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
    Avatar,
    Button,
    Chip
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';

import EditProfileDialog from "../components/profile/EditProfileDialog";
import Loading from "../components/utils/Loading";
import NotFound from "../components/utils/NotFound";
import { SnackbarNotification } from "../components/utils/Notifications";
import useAuth from "../hooks/useAuth";

import "./css/profile.css";

import { readUser } from "../functions/server-requests/user";
import dpSrc from "../functions/dpSrc";
import nameToColor from "../functions/nameToColor";
import dateSlicer from "../functions/dateSlicer";

const Profile = () => {
    const { userId } = useParams();
    const { auth } = useAuth();
    const [userDetails, setUserDetails] = useState(null);
    const [openEditProfileDialog, setOpenEditProfileDialog] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const userDetailsFunc = async () => {
            const userDetailsRes = await readUser(userId);

            if (userDetailsRes.status === 200) {
                setUserDetails(userDetailsRes.data.userDetails);

                document.title = `${userDetailsRes.data.userDetails.name} - Profile - DSolve`;
            }
            else {
                setUserDetails(undefined);
            }
        }

        userDetailsFunc();
    }, [userId]);

    if (userDetails === null) {
        return <Loading />;
    }

    else if (userDetails === undefined) {
        return <NotFound whatNotFound="User" />;
    }

    else {
        return (
            <>
                <div className="profile">
                    {auth.userId === userId &&
                        <div className="profile-update-button">
                            <Button
                                variant="contained"
                                onClick={() => setOpenEditProfileDialog(true)}
                            >
                                <EditIcon />
                            </Button>
                        </div>
                    }

                    <Avatar
                        src={dpSrc(userId)}
                        alt={userDetails.name}
                        sx={{
                            bgcolor: nameToColor(userDetails.name),
                            width: 100,
                            height: 100,
                            fontSize: 50
                        }}
                    />

                    <div className="profile-section">
                        <span className="title b-title">
                            {userDetails.name}
                        </span>
                    </div>

                    <div className="profile-section">
                        <span className="joined-on-color">
                            Joined on <strong>{dateSlicer(userDetails.joinedOn)}</strong>
                        </span>
                    </div>

                    <div className="profile-section">
                        <Chip
                            variant="outlined"
                            color="primary"
                            label={userDetails.email}
                            icon={<EmailIcon />}
                        />
                    </div>
                </div>

                <EditProfileDialog
                    openEditProfileDialog={openEditProfileDialog}
                    setOpenEditProfileDialog={setOpenEditProfileDialog}
                    userDetails={userDetails}
                    setUserDetails={setUserDetails}
                    setOpenSnackbar={setOpenSnackbar}
                    setSnackbarMessage={setMessage}
                />

                <SnackbarNotification
                    openSnackbar={openSnackbar}
                    setOpenSnackbar={setOpenSnackbar}
                    severity="success"
                    message={message}
                />
            </>
        );
    }
}

export default Profile;